import React from "react";
import "./ContactUsCard.scss";

export default function ContactUsCard({ children, className = "", href="#-", ...rest }) {
	return (
		<a className={`contact-us-card ${className}`} href={href} {...rest} target="_blank" rel="noreferrer">
			<div className="contact-us-card-content">{children}</div>
		</a>
	);
}
